import React, { Fragment, useCallback } from 'react';
import styles from './ContentSection.module.css';
import { useAppDispatch } from 'app/hooks';
import { RowSection as RowSectionType, moveSectionItem } from 'features/document/documentSlice';
import EmptyPage from '../PageBuilder/components/EmptyPage/EmptyPage';
import RowSection from './components/RowSection/RowSection';
import AddSection from './components/AddSection/AddSection';

interface Props {
  pageId: string;
  rows: RowSectionType[];
}

const ContentSection: React.FC<Props> = ({ pageId, rows }) => {
  const dispatch = useAppDispatch();

  const renderSection = useCallback(
    (row: RowSectionType, pageId: string, index: number) => {
      const moveSection = (pageId: string, index: number, isTop: boolean) => {
        dispatch(moveSectionItem({ pageId, index, isTop }));
      };
      return (
        <Fragment key={row.id}>
          <RowSection row={row} pageId={pageId} moveSection={moveSection} index={index} />
          <div className={styles.addSectionContainer}>
            <div className={styles.addSection}>
              <AddSection pageId={pageId} sectionId={row.id} />
            </div>
          </div>
        </Fragment>
      );
    },
    [dispatch]
  );

  return (
    <div className={styles.container}>
      <div className={styles.addSectionContainer}>
        <div className={styles.addSection}>
          <AddSection pageId={pageId} />
        </div>
      </div>
      {rows.map((row, index) => {
        return renderSection(row, pageId, index);
      })}
      {!rows.length && <EmptyPage />}
    </div>
  );
};

export default ContentSection;
